
export enum CALENDAR_TYPE {
    CHECK = "CHECK",
    CHOICE = "CHOICE"
}